import {
  type GetWorkspaceResponse,
  getWorkspace,
} from '@otter-ai/recall-client';
import { HOUR_MS } from '@/constants/time';

export const queryKey = ['workspace'] as const;
type QueryKey = typeof queryKey;

export type WorkspaceQuery = {
  readonly queryKey: QueryKey;
  readonly queryFn: () => Promise<GetWorkspaceResponse | null>;
  readonly staleTime: number;
  readonly enabled?: boolean;
  readonly retry?: number;
};

export function workspaceQueryCreator({
  enabled,
}: {
  enabled?: boolean;
} = {}): WorkspaceQuery {
  return {
    queryKey,
    queryFn: async () => {
      const response = await getWorkspace({
        // throwOnError: true,
        query: {},
      });
      if (!response.error) {
        return response.data;
      }
      if (response.response.status === 404) {
        return null;
      }
      throw response.error;
    },
    staleTime: HOUR_MS,
    enabled,
    retry: 3,
  };
}
